import * as Sentry from "@sentry/gatsby";

const env = process.env.GATSBY_ENVIRONMENT || process.env.NODE_ENV;
const enabled = env === "production" || env === "staging";

Sentry.init({
  dsn: "https://43dd465ad173478e8f78341e734668eb@o99321.ingest.us.sentry.io/5422022",
  environment: env,
  enabled: enabled,

  // Adds request headers and IP for users, for more info visit:
  // https://docs.sentry.io/platforms/javascript/guides/gatsby/configuration/options/#sendDefaultPii
  sendDefaultPii: true,

  integrations: [
  ],

  beforeSend(event) {
    event.tags = {
      ...(event.tags || {}),
      runtime: typeof window === "undefined" ? "ssr" : "browser",
    };
    return event;
  },

});

